module.exports = __webpack_public_path__ + "static/media/logo.d634ef06.svg";